var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"project-things-tab"},[_c('thingFirstLevel',{attrs:{"disable-drag-n-drop":true,"disable-check":_vm.isMotherPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }